import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import Picture from "./Picture"
import RichText from "./RichText"

const StyledIconList = styled.ul`
  &,
  & & {
    ${tw`ml-0`}
  }
  p + & {
    ${tw`mt-8`}
  }
`

const StyledIconListItem = styled.li`
  ${tw`flex`}
  & + &,
  & ul & {
    ${tw`mt-8`}
  }
`
const IconCol = styled.div`
  ${tw`w-16 md:w-24 pr-4`}
  flex-shrink: 0;
`
const TextCol = styled.div`
  ${tw`flex-1`}
  min-width: 1px; /* Fixes issue with nested flex items in IE11 */
`

const IconListBlock = ({ block }) => {
  const iconListItems = get(block, "elements.list_items.value") || []

  return (
    <StyledIconList>
      {iconListItems.map((item) => {
        const id = get(item, "system.id")

        return <IconListItem item={item} key={id} />
      })}
    </StyledIconList>
  )
}

export default IconListBlock

const IconListItem = ({ item }) => {
  const icon = get(
    item,
    "elements.icon.value[0].elements.image.value[0]"
  )
  const altText = get(
    item,
    "elements.image.value[0].elements.alt_text.value"
  )

  const text = get(item, "elements.text.value")

  return (
    <StyledIconListItem>
      <IconCol>
        {icon && (
          <Picture image={icon} cropWidth={128} cropRatio={1} alt={altText} />
        )}
      </IconCol>
      <TextCol>
        <RichText
          linkedItems={get(item, "elements.text.modular_content")}
          region="Icon List"
        >
          {text}
        </RichText>
      </TextCol>
    </StyledIconListItem>
  )
}
